import UserMenu from "../Admin/User/UserMenu";
import {
	NavTabs,
	NavTab,
	NavTabList,
	NavTabPanel,
} from "../../components/NavTabs/NavTabs";
import DraftEntriesTab from "./DraftEntriesTab";
import CartTab from "./CartTab";
import PaymentTab from "./Payment";
import OrdersTab from "./OrdersTab";
import { UserPageContainer } from "../../components/UserPageTemplate/UserPageTemplate";
import { useEffect, useState, createContext, useContext } from "react";
import { Link } from "react-router-dom";
import PrimaryLogo from "../../components/PrimaryLogo/PrimaryLogo";
import { EntryNavTabList } from "../Entries/EntryForm";
import MyContextProvider from "./CheckoutContext";
import PrevEntriesTab from "./PreviousEntry/PrevEntriesTab";
import BrowserHeader from "../../components/BrowserHeader/BrowserHeader";

// Checkout page with entire checkout process (draft, cart, orders)
const Checkout = (props: { tab?: string }) => {
	const tabs = ["draft-entries", "cart", "orders", "entries-search"];
	const tabNames = ["Draft Entries", "My Cart", "Orders", "Entries Search"];

	const defaultTab = tabs.indexOf(props.tab || "draft-entries");
	// console.log("tab", props.tab, defaultTab);
	const [tabIndex, setTabIndex] = useState(defaultTab);

	useEffect(() => {
		setTabIndex(defaultTab);
	}, [defaultTab]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [tabIndex]);

	return (
		<MyContextProvider>
			<BrowserHeader title={`${tabNames[tabIndex]} | Clio Awards`} />
			<div className="flex flex-col w-full">
				<UserMenu />
				<NavTabs
					className="flex flex-col flex-1"
					selectedIndex={tabIndex}
					onSelect={(index) => setTabIndex(index)}
				>
					<EntryNavTabList>
						<PrimaryLogo className="mb-[66px] pt-[0.18rem]" />{" "}
						{/* added pt-0.18rem */}
						<NavTab>
							<Link className="no-underline" to="/entries/draft-entries">
								Draft Entries
							</Link>
						</NavTab>
						<NavTab>
							<Link className="no-underline" to="/entries/cart">
								My Cart
							</Link>
						</NavTab>
						<NavTab>
							<Link className="no-underline" to="/entries/orders">
								Orders
							</Link>
						</NavTab>
						<NavTab>
							<Link className="no-underline" to="/entries/entries-search">
								Entries Search
							</Link>
						</NavTab>
					</EntryNavTabList>
					<NavTabPanel>
						<UserPageContainer className="flex-1">
							<DraftEntriesTab />
						</UserPageContainer>
					</NavTabPanel>
					<NavTabPanel>
						<UserPageContainer className="flex-1">
							<CartTab />
						</UserPageContainer>
					</NavTabPanel>
					{/* <NavTabPanel>
          <UserPageContainer className="flex-1">
            <PaymentTab
              paymentType="Credit Card"
              //   paymentType="Check"
              //   paymentType="Bank Transfer"
            />
          </UserPageContainer>
        </NavTabPanel> */}
					<NavTabPanel>
						<UserPageContainer className="flex-1">
							<OrdersTab />
						</UserPageContainer>
					</NavTabPanel>
					<NavTabPanel>
						<UserPageContainer className="flex-1">
							<PrevEntriesTab />
						</UserPageContainer>
					</NavTabPanel>
				</NavTabs>
			</div>
		</MyContextProvider>
	);
};

export default Checkout;
